import styled from "styled-components";

export const FileTag = styled.span`
  display: inline-flex;
  align-items: center;
  background: #f5f5f5;
  border-radius: 4px;
  padding: 2px 6px;
  margin-right: 6px;
  font-size: 12px;
  color: #333;
  max-width: 120px;
  min-width: 60px;
  min-height: 24px;
  overflow: hidden;
  position: relative;
  .file-name {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    max-width: 80px;
  }
`;

export const EllipsisBadge = styled.span`
  display: inline-block;
  background: #e0e0e0;
  border-radius: 4px;
  width: 32px;
  height: 24px;
  text-align: center;
  line-height: 24px;
  font-size: 16px;
  color: #333;
  cursor: pointer;
  margin-left: 4px;
`;

export const RemoveFile = styled.span`
  cursor: pointer;
  color: #ff4d4f;
  font-weight: bold;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  &:hover {
    background: #ff4d4f22;
  }
`;

export const FileList = styled.div`
  display: flex;
  align-items: center;
  min-height: 26px;
  margin-top: -25px;
  margin-bottom: 4px;
`;

export const TooltipFileList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 250px;
  overflow-y: auto;
  padding: 4px;

  /* Custom scrollbar for better look in tooltip */
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 4px;
  }
`;
